import { type PropsWithChildren, useCallback } from "react";
import type { ChatPropertiesType } from "@b2bportal/chat-api";
import type { ChatTransfer } from "@b2bportal/ivr-api";
import {
  ChatSupportContext,
  type IChatSupportContext,
} from "@hopper-b2b/self-serve";
import { openNubankChat } from "../../utils/nubankHandoff";

export const NuchatProvider = ({ children }: PropsWithChildren) => {
  const openChatWindow = useCallback(() => {
    openNubankChat();
  }, []);

  const openGeneralSupportChat = useCallback(async () => {
    openNubankChat();
  }, []);

  const openProductSpecificSupportChat = useCallback(
    async (
      _productId: string, // Unused currently
      _productType: ChatPropertiesType, // Unused currently
      _requestType: string, // Unused currently
      _chatTransfer?: ChatTransfer // Unused currently
    ) => {
      openNubankChat();
    },
    []
  );

  const supportContext: IChatSupportContext = {
    openChatWindow,
    generalSupportChat: openGeneralSupportChat,
    productSupportChat: openProductSpecificSupportChat,
  };

  return (
    <ChatSupportContext.Provider value={supportContext}>
      {children}
    </ChatSupportContext.Provider>
  );
};
